import { Component } from 'react';
import ValidationRule from './validationRules/ValidationRule';

class InputValidator extends Component {
  componentWillMount() {
    const rules = (this.props.children || []).filter((child) => child instanceof ValidationRule);
    rules.forEach((rule) => rule.register(this.props.validationRules));
  }

  render() {
    return null;
  }
}

export default InputValidator;



// WEBPACK FOOTER //
// ./src/common/core/validation/InputValidator.jsx